<template>
  <div class="details">
    <details-header :baseInfo="baseInfo"></details-header>
    <div class="details_main">
      <div class="item_container">
        <base-information :baseInfo="baseInfo"></base-information>
      </div>
      <div class="item_container">
        <assessment-report :evalData="evalData"></assessment-report>
      </div>

      <div class="item_container">
        <videoAnalysis :videoData="videoData"></videoAnalysis>
      </div>

      <div class="item_container">
        <physical-data :testReport="testReport"></physical-data>
      </div>

      <div class="item_container">
        <injury :injuryData="injuryData"></injury>
      </div>
    </div>
  </div>
</template>

<script>
import detailsHeader from "./components/details-header/index.vue";
import baseInformation from "./components/basic-information/index.vue";
import assessmentReport from "./components/assessment-report/index.vue";
import videoAnalysis from "./components/video-analysis/index.vue";
import physicalData from "./components/physical-data/index.vue";
import injury from "./components/injury/index.vue";

export default {
  components: {
    detailsHeader,
    baseInformation,
    assessmentReport,
    videoAnalysis,
    physicalData,
    injury,
  },
  data() {
    return {
      baseInfo: {},
      evalData: [],
      videoData: {},
      testReport: [],
      injuryData: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { tenant_id, id } = this.$route.query;
      this.getPlayerData(id, tenant_id);
      this.getEvalData(id, tenant_id);
      this.getPlayerVideo(id, tenant_id);
      this.getPlayerReport(id, tenant_id);
      this.getPlayerInjury(id, tenant_id);
    },
    // 球员详情信息
    getPlayerData(id, tenant_id) {
      this.$server.getPlayerDetails(id, tenant_id).then((res) => {
        this.baseInfo = res.data;
      });
    },
    // 获取球员评估
    getEvalData(id, tenant_id) {
      this.$server.getPlayerEvel(id, tenant_id).then((res) => {
        this.evalData = res.data;
      });
    },
    // 获取球员视频分析数据
    getPlayerVideo(id, tenant_id) {
      this.$server.getPlayerVideo(id, tenant_id).then((res) => {
        this.videoData = res.data;
      });
    },
    // 获取球员体测数据
    getPlayerReport(id, tenant_id) {
      this.$server.getPlayerTestReport(id, tenant_id).then((res) => {
        this.testReport = res.data;
      });
    },
    // 获取球员伤病信息
    getPlayerInjury(id, tenant_id) {
      this.$server.getInjuryData(id, tenant_id).then((res) => {
        this.injuryData = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.details {
  width: 100%;
  height: 100%;
}
.details_main {
  width: 100%;
  height: calc(100% - 158px);
  padding: 16px 24px;
  box-sizing: border-box;
  overflow-y: auto;
}
.item_container {
  background-color: #fff;
  padding: 0 24px;
  margin-top: 12px;
  padding-bottom: 24px;
}
</style>
